(() => {
  const push = (event, details = {}) => {
    const payload = { event, page_type: 'homepage', ...details };
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent(`secret-santa:${event}`, { detail: payload }));
  };

  const mountBudgetNav = () => {
    const shortcuts = document.querySelector('main[data-template="index"] .ss-shortcuts');
    if (!shortcuts) return;

    let zone = document.querySelector('main[data-template="index"] .ss-home-choice-zone');
    if (!zone) {
      zone = document.createElement('div');
      zone.className = 'ss-home-choice-zone';
      shortcuts.parentNode.insertBefore(zone, shortcuts);
      zone.appendChild(shortcuts);
    }

    if (zone.querySelector('.ss-home-budget-nav')) return;

    const nav = document.createElement('nav');
    nav.className = 'ss-home-budget-nav';
    const lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    const config = ({
      fr: { aria: 'Cadeaux Secret Santa par budget', label: 'Par budget', items: [['/collections/cadeau-secret-santa-10-euros','10 € et moins'],['/collections/cadeau-secret-santa-10-15-euros','10–15 €'],['/collections/cadeau-secret-santa-15-20-euros','15–20 €'],['/collections/cadeau-secret-santa-plus-de-20-euros','20 € et +']] },
      es: { aria: 'Regalos de Amigo Invisible por presupuesto', label: 'Por presupuesto', items: [['/collections/regalos-amigo-invisible-hasta-10-euros','Hasta 10 €'],['/collections/regalos-amigo-invisible-10-15-euros','10–15 €'],['/collections/regalos-amigo-invisible-15-20-euros','15–20 €'],['/collections/regalos-amigo-invisible-mas-20-euros','Más de 20 €']] },
      en: { aria: 'Secret Santa gifts by budget', label: 'By budget', items: [['/collections/secret-santa-gifts-under-10','$10 and under'],['/collections/secret-santa-gifts-10-15','$10–$15'],['/collections/secret-santa-gifts-15-20','$15–$20'],['/collections/secret-santa-gifts-over-20','$20+']] }
    })[lang] || { aria: 'Secret Santa gifts by budget', label: 'By budget', items: [] };
    nav.setAttribute('aria-label', config.aria);
    nav.innerHTML = `<span class="ss-home-budget-nav__label">${config.label}</span>` + config.items.map(([href,label]) => `<a class="ss-home-budget-nav__link" href="${href}">${label}</a>`).join('');
    zone.insertBefore(nav, shortcuts);
  };

  const bypassUnavailableEmailSave = () => {
    document.querySelectorAll('main[data-template="index"] [data-ss-quiz]').forEach((root) => {
      const form = root.querySelector('[data-ss-quiz-form]');
      if (!form || form.dataset.ssEmailGuard === 'true') return;
      form.dataset.ssEmailGuard = 'true';
      form.addEventListener('submit', () => {
        if (window.SecretSantaQuizEmailCapture?.submit) return;
        queueMicrotask(() => {
          const save = root.querySelector('[data-ss-quiz-save]');
          const skip = root.querySelector('[data-ss-email-skip]');
          if (save && !save.hidden && skip) skip.click();
        });
      }, true);
    });
  };

  const syncFeaturedCarouselArrows = () => {
    document.querySelectorAll('main[data-template="index"] [data-ss-category-carousel]').forEach((root) => {
      const track = root.querySelector('[data-ss-carousel-track]');
      const prev = root.querySelector('[data-ss-carousel-prev]');
      const next = root.querySelector('[data-ss-carousel-next]');
      const originals = [...root.querySelectorAll('[data-ss-featured-card]')];
      if (!track || !prev || !next || !originals.length) return;

      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      const cardWidth = originals[0].getBoundingClientRect().width;
      const originalWidth = (cardWidth * originals.length) + (gap * Math.max(0, originals.length - 1));
      const overflow = originalWidth > track.clientWidth + 3;
      prev.hidden = !overflow;
      next.hidden = !overflow;
      if (!overflow) return;

      prev.disabled = false;
      next.disabled = false;
    });
  };

  const classify = (anchor) => {
    if (anchor.classList.contains('ss-featured-card')) return ['homepage_collection_clicked', 'featured'];
    if (anchor.classList.contains('ss-shortcut')) return ['homepage_collection_clicked', 'shortcut'];
    if (anchor.classList.contains('ss-home-budget-nav__link')) return ['homepage_collection_clicked', 'budget'];
    if (anchor.classList.contains('ss-product-row__all-link')) return ['homepage_collection_clicked', 'curated_row'];
    if (anchor.pathname?.includes('/products/')) return ['homepage_product_clicked', 'products'];
    return null;
  };

  const boot = () => {
    mountBudgetNav();
    bypassUnavailableEmailSave();
    syncFeaturedCarouselArrows();
    window.addEventListener('resize', () => requestAnimationFrame(syncFeaturedCarouselArrows), { passive: true });
    document.querySelectorAll('main[data-template="index"] [data-ss-carousel-track]').forEach((track) => {
      track.addEventListener('scroll', () => requestAnimationFrame(syncFeaturedCarouselArrows), { passive: true });
    });

    document.querySelector('main[data-template="index"]')?.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[href]');
      if (!anchor) return;
      const info = classify(anchor);
      if (!info) return;
      push(info[0], {
        placement: info[1],
        label: (anchor.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120),
        href: anchor.pathname + anchor.search,
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
